/* eslint-disable no-undef */
const Cart = () => {
  /*
   * Show and hide cart
   */

  const cartButton = document.querySelector('.top-header__cart-button');
  const cart = document.querySelector('.top-header__shopping-cart');
  const message = document.querySelector('#top-header .woocommerce-message');
  const info = document.querySelector('#top-header .woocommerce-info');
  const error = document.querySelector('#top-header .woocommerce-error');
  const updateCartButton = document.querySelector('button[name=update_cart]');
  const applyCodeButton = document.querySelector('button[name=apply_coupon]');
  let cartInputs;
  if (cart) {
    cartInputs = cart.querySelectorAll('input');
  }

  function handleOutsideCartClick(event) {
    if (!cart || !cartButton) return;
    const isClickInside =
      cart.contains(event.target) || cartButton.contains(event.target);
    if (!isClickInside) {
      cart.classList.add('hidden');
      cart.classList.add('not-visible');
    }
  }

  if (cartButton && cart) {
    cartButton.addEventListener('click', () => {
      cart.classList.toggle('hidden');
      cart.classList.toggle('not-visible');
      if (!cart.classList.contains('hidden')) {
        document.addEventListener('click', handleOutsideCartClick);
      }
      if (cart.classList.contains('hidden')) {
        document.removeEventListener('click', handleOutsideCartClick);
      }
      if (info && cart) {
        message.classList.add('hidden');
        cart.classList.remove('info');
      }
      if (message && cart) {
        message.classList.add('hidden');
        cart.classList.remove('message');
      }
      if (error && cart) {
        error.classList.add('hidden');
        cart.classList.remove('alert');
      }
    });
  }

  if (info) {
    cart.classList.remove('hidden');
    document.addEventListener('click', handleOutsideCartClick);
    setTimeout(() => {
      cart.classList.remove('not-visible');
    }, 100);
    cart.classList.add('info');
  }

  if (message) {
    cart.classList.remove('hidden');
    document.addEventListener('click', handleOutsideCartClick);
    setTimeout(() => {
      cart.classList.remove('not-visible');
    }, 100);
    cart.classList.add('message');
  }

  if (error) {
    cart.classList.remove('hidden');
    document.addEventListener('click', handleOutsideCartClick);
    setTimeout(() => {
      cart.classList.remove('not-visible');
    }, 100);
    cart.classList.add('error');
  }

  if (cartInputs && updateCartButton) {
    cartInputs.forEach((ci) => {
      if (ci.name !== 'coupon_code') {
        ci.addEventListener('click', () => {
          updateCartButton.classList.add('changed');
        });
      } else {
        ci.addEventListener('change', (event) => {
          if (event.target.value !== '') {
            applyCodeButton.classList.add('changed');
          } else if (event.target.value === '') {
            applyCodeButton.classList.remove('changed');
          }
        });
      }
    });
  }

  // Hide multiple option switching in main cart.
  const subs = document.querySelectorAll('.maincart .wcsatt-options');
  if (subs && subs.length) {
    subs.forEach((sub) => {
      if (sub) {
        const lis = sub.querySelectorAll('li');
        if (lis) {
          lis.forEach((li) => {
            if (!li.querySelector("input[checked='checked']")) {
              li.classList.add('not-checked');
            }
          });
        }
      }
    });
  }
};

export default Cart;
